module.exports = __webpack_public_path__ + "static/media/Question.cff55776.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Support/images/Question.svg
 ** module id = 1320
 ** module chunks = 0
 **/